import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const catalogAttributeRoutes: Routes = [
  {
    path: 'catalog-attributes',
    loadComponent: () =>
      import('./catalog-attributes.component').then((c) => c.CatalogAttributesComponent),
    canActivate: [AuthGuard],
  },
];
